import React from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { LayoutDashboard, Package, Ticket, CreditCard, FileText, LogOut, ExternalLink } from 'lucide-react'

const Header = ({ isAdmin = false }) => {
  const { logout, isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const adminNavItems = [
    { path: '/co', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/co/products', label: 'Products', icon: Package },
    { path: '/co/codes', label: 'Codes', icon: Ticket },
    { path: '/co/redemptions', label: 'Redemptions', icon: CreditCard },
    { path: '/co/audit', label: 'Audit', icon: FileText },
  ]

  if (isAdmin) {
    return (
      <header className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 flex items-center justify-between h-12">
          <Link to="/admin" className="text-base font-bold text-gray-900">G2Bulk</Link>
          <nav className="hidden md:flex items-center space-x-1">
            {adminNavItems.map(item => {
              const Icon = item.icon
              const active = location.pathname === item.path
              return (
                <Link key={item.path} to={item.path}
                  className={`flex items-center space-x-1 px-2.5 py-1 rounded text-sm ${active ? 'text-blue-600 bg-blue-50' : 'text-gray-500 hover:text-gray-800'}`}>
                  <Icon size={14} />
                  <span>{item.label}</span>
                </Link>
              )
            })}
          </nav>
          <div className="flex items-center space-x-3">
            <Link to="/" className="text-gray-400 hover:text-gray-600"><ExternalLink size={14} /></Link>
            {isAuthenticated && (
              <button onClick={() => { logout(); navigate('/co/login') }} className="text-gray-400 hover:text-red-500"><LogOut size={14} /></button>
            )}
          </div>
        </div>
        {/* Mobile nav */}
        <div className="md:hidden border-t border-gray-100 overflow-x-auto">
          <nav className="flex px-4 py-1.5 space-x-1">
            {adminNavItems.map(item => {
              const Icon = item.icon
              const active = location.pathname === item.path
              return (
                <Link key={item.path} to={item.path}
                  className={`flex items-center space-x-1 px-2 py-1 rounded text-xs whitespace-nowrap ${active ? 'text-blue-600 bg-blue-50' : 'text-gray-400'}`}>
                  <Icon size={12} />
                  <span>{item.label}</span>
                </Link>
              )
            })}
          </nav>
        </div>
      </header>
    )
  }

  return (
    <header className="border-b border-gray-200">
      <div className="container mx-auto px-4 flex items-center justify-between h-14">
        <Link to="/" className="text-xl font-bold text-gray-900 tracking-tight">G2Bulk</Link>
        <a href="https://g2bulk.com" className="text-gray-400 hover:text-gray-600 text-sm" target="_blank" rel="noopener">g2bulk.com</a>
      </div>
    </header>
  )
}

export default Header
